<nz-spin [nzSpinning]="isLoading">
  <div class="container">
    <h2>Cancelled/Chargeback Review</h2>

    <nz-table #basicTable [nzData]="cancelledReviews" (nzQueryParams)="onQueryParamsChange($event)">
      <thead>
        <tr>
          <th nzColumnKey="order_id" [nzSortFn]="true">Account Number</th>
          <th nzColumnKey="customer_name" [nzSortFn]="true">Customer Name</th>
          <th nzColumnKey="address_line_1" [nzSortFn]="true">Address</th>
          <th nzColumnKey="sale_date" [nzSortFn]="true">Sale Date</th>
          <th nzColumnKey="eligibility_status_submitted_date" [nzSortFn]="true">Submitted Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of basicTable.data">
          <td>{{ order.order_id }}</td>
          <td>{{ order.first_name | titlecase }} {{ order.last_name | titlecase }}</td>
          <td>{{ order.address_line_1 }} {{ order.address_city }}, {{ order.address_state }}, {{ order.address_zip }}</td>
          <td>{{ order.sale_date | date }}</td>
          <td>{{ order.eligibility_status_submitted_date | date }}</td>
          <td>
            <button nz-button nzType="primary" (click)="showResolveModal(order)">Resolve</button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-spin>

<nz-modal [(nzVisible)]="isModalVisible" nzTitle="Manual Review" [nzFooter]="null" (nzOnCancel)="handleCancel()">
  <ng-container *nzModalContent>
    <nz-form [nzLayout]="'vertical'">
      <nz-form-item>
        <nz-form-label nzRequired>What do you want to do with this order?</nz-form-label>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Name</nz-form-label>
        <nz-form-control>
          <span>{{ selectedOrder?.first_name | titlecase }} {{ selectedOrder?.last_name | titlecase }}</span>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Address</nz-form-label>
        <nz-form-control>
          <span>
            {{ selectedOrder?.address_line_1 }}, 
            {{ selectedOrder?.address_city }}, 
            {{ selectedOrder?.address_state }}
          </span>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Sale Date</nz-form-label>
        <nz-form-control>
          <span>{{ selectedOrder?.sale_date | date }}</span>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Account Number</nz-form-label>
        <nz-form-control>
          <span>{{ selectedOrder?.order_id }}</span>
        </nz-form-control>
      </nz-form-item>
    </nz-form>

    <p>Eligibility Notes:</p>
    <!-- <div *ngFor="let note of selectedOrder?.eligibility_notes">
      <div>** {{ note.text }} ({{ note.date_created | date }} by {{ note.user_first }} {{ note.user_last }}) **</div>
    </div> -->

<div *ngIf="!selectedOrder?.eligibility_status_submitted_date" style="margin-top: 10px;">
  <p>Submitted To Fidium</p>
  <button nz-button nzType="primary" (click)="submit()">Submit</button>
</div>
<div *ngIf="selectedOrder?.eligibility_status_submitted_date">
  <button nz-button nzType="primary" (click)="complete()">Complete</button>
</div>

<div style="margin-top: 10px;">
  <button (click)="showNoteModal()">Add Note</button>
</div>
  </ng-container>
</nz-modal>

<!-- <nz-modal 
[(nzVisible)]="noteModal"
  nzTitle="Add Note"
  (nzOnCancel)="handleCancelNote()"
  (nzOnOk)="handleOkNote()">
  <ng-container *nzModalContent>
    <textarea nz-input [(ngModel)]="note" fill="outline" placeholder="Enter Notes"></textarea>
  </ng-container>
</nz-modal> -->